import { render, staticRenderFns } from "./InformacionContact.vue?vue&type=template&id=80057a80&scoped=true"
import script from "./InformacionContact.vue?vue&type=script&lang=js"
export * from "./InformacionContact.vue?vue&type=script&lang=js"
import style0 from "./InformacionContact.vue?vue&type=style&index=0&id=80057a80&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "80057a80",
  null
  
)

export default component.exports